// src/services/httpClient.js
import axios from "axios";

const { REACT_APP_REST_URL } = process.env;

const TOKEN_KEY = "cbrne_token";

const httpClient = axios.create({
  baseURL: REACT_APP_REST_URL,
  headers: {
    "Content-Type": "application/json"
  }
});

// Attach the JWT to every request
httpClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

httpClient.interceptors.response.use(
  response => response, // return response as-is on success
  error => {
    const { response } = error;

    // Global error handling
    if (response) {
      switch (response.status) {
        case 400:
          console.error("Bad request:", response.data?.message || response.statusText);
          break;
        case 401: {
          // Session expired or not logged in — clear credentials and go to login,
          // but never redirect while already on the login page (avoids a loop).
          const isLoginRequest = response.config?.url?.includes("/auth/login");
          if (!isLoginRequest && window.location.pathname !== "/login") {
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem("cbrne_user");
            window.location.href = "/login";
          }
          break;
        }
        case 403:
          console.error("Forbidden:", response.data?.message);
          break;
        case 404:
          console.error("Resource not found.");
          break;
        case 500:
          console.error("Server error.");
          break;
        default:
          console.error(`Error ${response.status}:`, response.data?.message || response.statusText);
      }
    } else {
      console.error("Network or CORS error:", error.message);
    }

    return Promise.reject(error); // still propagate error to components if needed
  }
);

export default httpClient;
